export default `
/*
  Warnings:

  - You are about to drop the column \`file_id\` on the \`ProfilePublicTrack\` table. All the data in the column will be lost.

*/
-- RedefineTables
PRAGMA defer_foreign_keys=ON;
PRAGMA foreign_keys=OFF;
CREATE TABLE "new_ProfilePublicTrack" (
    "id" TEXT NOT NULL PRIMARY KEY,
    "user_id" TEXT NOT NULL,
    "file_revision_id" TEXT NOT NULL,
    "workspace_id" TEXT NOT NULL,
    "created_by" TEXT NOT NULL,
    "created_at" DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP,
    CONSTRAINT "ProfilePublicTrack_file_revision_id_fkey" FOREIGN KEY ("file_revision_id") REFERENCES "FileRevision" ("id") ON DELETE RESTRICT ON UPDATE CASCADE,
    CONSTRAINT "ProfilePublicTrack_workspace_id_fkey" FOREIGN KEY ("workspace_id") REFERENCES "Workspace" ("id") ON DELETE RESTRICT ON UPDATE CASCADE
);
INSERT INTO "new_ProfilePublicTrack" ("created_at", "created_by", "file_revision_id", "id", "user_id", "workspace_id") SELECT "created_at", "created_by", "file_revision_id", "id", "user_id", "workspace_id" FROM "ProfilePublicTrack";
DROP TABLE "ProfilePublicTrack";
ALTER TABLE "new_ProfilePublicTrack" RENAME TO "ProfilePublicTrack";
CREATE INDEX "ProfilePublicTrack_user_id_idx" ON "ProfilePublicTrack"("user_id");
CREATE INDEX "ProfilePublicTrack_file_revision_id_idx" ON "ProfilePublicTrack"("file_revision_id");
CREATE INDEX "ProfilePublicTrack_workspace_id_idx" ON "ProfilePublicTrack"("workspace_id");
CREATE INDEX "ProfilePublicTrack_created_by_idx" ON "ProfilePublicTrack"("created_by");
CREATE INDEX "ProfilePublicTrack_created_at_idx" ON "ProfilePublicTrack"("created_at");
CREATE UNIQUE INDEX "ProfilePublicTrack_user_id_file_revision_id_key" ON "ProfilePublicTrack"("user_id", "file_revision_id");
PRAGMA foreign_keys=ON;
PRAGMA defer_foreign_keys=OFF;
`;
